export interface ConfigObj {
  debug: boolean;
  isStage: boolean;
}

export const configObj: ConfigObj = {
    debug: false,
    isStage: false
};
